import { writable } from "svelte/store"

export const textHTML = writable(``)
